<template>
  <div class="aside">
    <el-aside id="asideNav">
      <el-menu
        :default-active="$route.path"
        class="el-menu-vertical"
        @select="selectmenu"
        :collapse="$store.getters.isCollapse"
        background-color="#222d32"
        text-color="rgba(255,255,255,.7)"
        active-text-color="#ffffff"
        :router="$store.getters.uniquerouter"
        :unique-opened="$store.getters.uniquerouter"
        :collapse-transition="true"
      >
        <div class="logo-name flex_jus_cen flex_align">
          <img
            class="block"
            src="../../../assets/image/logo.png"
            alt=""
            srcset=""
          />
          <!-- @click="show" -->
        </div>
        <div
          v-if="
            $store.state.userInfo.page == 'developer' ||
              $store.state.userInfo.page == 'super'
          "
          class="sub"
        >
          <template v-for="(item, index) in $store.getters.routers">
            <el-row v-if="!item.hidden" :key="index">
              <el-submenu
                v-if="!item.alone && item.children.length > 0"
                :index="index + ''"
              >
                <template slot="title">
                  <i
                    :class="item.iconCls ? item.iconCls : [fa, fa - server]"
                  ></i>
                  <span slot="title">{{ $t(`routeName.${item.name}`) }}</span>
                </template>
                <menu-tree :menuData="item.children"></menu-tree>
              </el-submenu>
              <el-menu-item :index="item.path" v-else>
                <i :class="item.iconCls ? item.iconCls : [fa, fa - file]"></i>
                <span slot="title">{{ $t(`routeName.${item.name}`) }}</span>
              </el-menu-item>
            </el-row>
          </template>
        </div>
        <div v-else :class="!$store.getters.isCollapse ? 'submenu-box' : 'sub'">
          <el-submenu
            :index="index.toString()"
            v-for="(item, index) in $store.state.userInfo.mapInfo.menusFunction"
            :key="index"
          >
            <template slot="title">
              <em :class="item.fnIcon"></em>{{ item.fnName }}
            </template>
            <el-menu-item-group v-for="(el, dex) in item.childNodes" :key="dex">
              <el-menu-item :index="el.fnPath">
                <em :class="el.fnIcon" class="fnIcon"></em>
                {{ el.fnName }}
              </el-menu-item>
            </el-menu-item-group>
          </el-submenu>
          <!-- <vuedraggable
            class="submenu"
            :move="datadragStart"
            @update="datadragEnd"
            v-model="collectionList"
            :parent="true"
            ghost-class="ghost"
            :options="{
              group: 'smenu',
              handle: '.el-icon-s-grid',
              animation: 350,
              dragClass: 'sortable-drag',
              chosenClass: 'sortable-chosen'
            }"
          >
            <transition-group name="smenu" tag="ul">
              <div class="box" v-for="item in collectionList" :key="item.fnId">
                <div
                  v-if="item.isCollection != 0"
                  ref="submenuLists"
                  class="submenu_list"
                >
                  <div
                    class="flex_align flex_jus_cen ml20"
                    @click="toredirect(item)"
                  >
                    <el-tooltip
                      v-if="$store.getters.isCollapse"
                      class="item flex_align"
                      effect="dark"
                      :content="item.fnName"
                      placement="right-start"
                    >
                      <em
                        :class="item.fnIcon"
                        style="font-size: 18px; padding-top: 18px"
                      ></em>
                    </el-tooltip>
                    <em
                      :class="item.fnIcon"
                      style="font-size: 18px"
                      v-if="!$store.getters.isCollapse"
                    ></em>
                    <span v-if="!$store.getters.isCollapse">{{
                      item.fnName
                    }}</span>
                  </div>
                  <div style="margin-right: 10px">
                    <em @click="del(item)" class="el-icon-close"></em>
                    <em class="el-icon-s-grid"></em>
                  </div>
                </div>
              </div>
            </transition-group>
          </vuedraggable> -->
        </div>
      </el-menu>
    </el-aside>
    <!-- <asideShow
      @getCollectionListInt="collectionListInt"
      :isshow="isshow"
      @show="show"
      ref="asideShows"
      v-if="
        $store.state.userInfo.mapInfo.userType != 'admin' &&
        $store.state.userInfo.page != 'super' &&
        $store.state.userInfo.page != 'developer'
      "
    /> -->
  </div>
</template>

<script>
import menuTree from "./menuTree";
import vuedraggable from "vuedraggable";
import asideShow from "./asideShow";
// import func from "../../../../vue-temp/vue-editor-bridge";
export default {
  name: "asidetitle",
  data() {
    return {
      isshow: false,
      collectionList: [], //左侧菜单栏数据
      nowCollectionList: [] // 储存侧边栏数据
    };
  },
  components: {
    menuTree,
    asideShow,
    vuedraggable
  },
  watch: {
    // 监听浏览器直接输入路由，将此路由添加到tabnavBox
    "$route.path": function(val) {
      this.selectmenu(val);
    }
  },
  methods: {
    selectmenu(key) {
      let router = this.$store.getters.routers;
      let name = "";
      let navTitle = function(path, routerARR) {
        for (let i = 0; i < routerARR.length; i++) {
          if (routerARR[i].children.length > 0 || routerARR[i].path === path) {
            if (
              routerARR[i].path === path &&
              routerARR[i].children.length < 1
            ) {
              name = routerARR[i].name;
              break;
            }
            navTitle(path, routerARR[i].children);
          }
        }
        return name;
      };
      this.$store.dispatch("addTab", {
        title: navTitle(key, router),
        path: key
      });
    },
    show() {
      this.isshow = !this.isshow;
    },
    // 拖拽开始的方法
    datadragStart(e) {
      // $(this.$refs.submenuLists[e.draggedContext.index])
      //   .parents("ul")
      //   .find(".submenu_list")
      //   .addClass("submenu_datadrag");
    },
    // 拖拽结束后的方法
    datadragEnd(e) {
      // $(this.$refs.submenuLists[0])
      //   .parents("ul")
      //   .find(".submenu_list")
      //   .removeClass("submenu_datadrag");
      // var obj = {};
      // this.nowCollectionList.forEach((el, index) => {
      //   if (e.oldIndex == index) {
      //     obj.oldCollectionId = el.collectionId;
      //     obj.oldSort = el.collectionSort;
      //   } else if (e.newIndex == index) {
      //     obj.newCollectionId = el.collectionId;
      //     obj.newSort = el.collectionSort;
      //   }
      // });
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.modifyFunctionCollSort,
      //   obj,
      //   false
      // ).then((res) => {
      //   this.collectionListInt();
      // });
    },
    // 获取用户收藏
    collectionListInt() {
      this.request(
        this.Appconstance.REQUEST_TYPE.POST,
        this.adminApi.homerenovation.getUserCollcetionFunction,
        {},
        false
      ).then(res => {
        this.collectionList = res.rows;
        // 克隆对象
        this.nowCollectionList = this.StringUtil.cloneObj(res.rows);
      });
    },
    // 路由跳转
    toredirect(item) {
      this.$router.history.push({
        path: item.fnPath
        // path: "/returnManagement",
        // path: "/orderManagement",productManagement,waveManagement,returnManagement
      });
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.addErpFunctionBrowse,
      //   { fnId: item.fnId },
      //   false
      // ).then((res) => {
      //   this.isshow = false;
      //   this.$router.history.push({
      //     path: "/returnManagement",
      //     // path: "/orderManagement",productManagement,waveManagement,returnManagement
      //   });
      // });
    },
    // 删除列表 取消收藏
    del(item) {
      // this.request(
      //   this.Appconstance.REQUEST_TYPE.POST,
      //   this.adminApi.homerenovation.delByModel + item.fnId,
      //   {},
      //   false,
      //   false
      // ).then((res) => {
      //   let arr = this.$store.state.userInfo.mapInfo.menusFunction;
      //   for (let i = 0, l = arr.length; i < l; i++) {
      //     if (arr[i].childNodes != null) {
      //       arr[i].childNodes.forEach((it, index) => {
      //         // console.log(it);
      //         if (it.fnName == item.fnName) {
      //           item.isCollection = it.isCollection = 0;
      //         }
      //       });
      //     }
      //   }
      //   this.$store.state.userInfo.mapInfo.menusFunction = arr;
      //   this.collectionListInt();
      //   this.$nextTick(function () {
      //     this.$refs.asideShows.collectionListInt();
      //   });
      //   this.MGridUtil.MessageShow("删除成功", "success");
      // });
    }
  },
  mounted() {
    this.$eventHub.$on("toshow", val => {
      this.isshow = val.bool;
    });
    // this.collectionListInt();
  }
};
</script>

<style lang="scss" scoped>
$top: top;
$bottom: bottom;
$left: left;
$right: right;
%w100 {
  width: 100%;
}
%h100 {
  height: 100%;
}
%cursor {
  cursor: pointer;
}
@mixin set-value($side, $value) {
  @each $prop in $leftright {
    #{$side}-#{$prop}: $value;
  }
}
#asideNav {
  width: auto !important;
  display: flex;
  flex-direction: column;
  border-right: solid 1px #e6e6e6;
  &::-webkit-scrollbar {
    display: none;
  }
  .logo-name {
    background-color: #222d32 !important;
    font-weight: 300;
    z-index: 999;
    position: absolute;
    width: 100%;
    height: 60px;
    p {
      text-align: center;
      padding: 12px 0;
    }
    img {
      cursor: pointer;
    }
  }
  .el-menu-vertical:not(.el-menu--collapse) {
    width: 200px;
    @extend %h100;
    overflow-y: scroll;
    scrollbar-width: none;
  }
  .el-menu {
    flex: 1;
    border-right: none;
    position: relative;
    &::-webkit-scrollbar {
      display: none;
    }
    .fa {
      vertical-align: middle;
      margin-right: 5px;
      width: 24px;
      text-align: center;
      font-size: 18px;
    }
    .el-menu-item {
      border-bottom: 1px solid #222d32;
      &:hover {
        color: #ffffff !important;
        background-color: #375573 !important;
      }
    }
    .el-menu-item.is-active {
      background-color: #8ac4ff !important;
    }
    .is-opened > .el-submenu__title > .el-icon-arrow-down {
      color: #ffffff;
      font-weight: 500;
      font-size: 18px;
    }
  }
}
.icon {
  font-size: 36px;
  cursor: pointer;
}
.submenu-box {
  height: 100%;
  padding-top: 60px;
}
.sub {
  padding-top: 60px;
}
.submenu {
  width: 200px;
  height: 100%;
  background-color: #222d32;
  overflow: hidden;
  overflow-y: scroll;
}
.submenu::-webkit-scrollbar {
  display: none; /* Chrome Safari */
  scrollbar-width: none;
}
.submenu .submenu_list {
  line-height: 40px;
  height: 40px;
  color: rgba(255, 255, 255, 0.7);
  cursor: pointer;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.mr95 {
  display: flex;
  align-items: center;
  margin-right: 95px;
}
.submenu .submenu_list .flex_align span {
  font-size: 14px;
  display: inline-block;
  padding-left: 5px;
  word-break: keep-all;
  overflow: hidden;
  text-overflow: ellipsis;
}
.submenu .submenu_list .el-icon-s-grid {
  cursor: move;
  display: none;
}
.submenu .submenu_list:hover {
  background-color: #377bff;
}
.submenu .submenu_datadrag {
  background-color: #222d32 !important;
}
.submenu .submenu_list:hover i,
.submenu .submenu_list:hover em {
  display: inline-block;
}
.submenu .submenu_list:hover .flex_align span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  width: 120px;
}

.sortable-ghost {
  line-height: 40px;
  height: 40px;
}
/* chosenClass: 设置被选中的元素的class */
.sortable-chosen {
  cursor: move;
}
.sortable-chosen span,
.sortable-chosen i,
.sortable-chosen em {
  color: #222d32;
}
/* dragClass:拖动元素的class。  */
.sortable-drag {
  line-height: 40px;
  height: 40px;
  background-color: #222d32;
}
.ml20 {
  margin-left: 20px;
  // width: 80%;
}
.sortable-drag span,
.sortable-drag i,
.sortable-drag em {
  color: rgba(255, 255, 255, 0.7);
}

.submenu .submenu_list .el-icon-s-grid {
  cursor: move;
  display: none;
}
.submenu .submenu_list .el-icon-close {
  display: none;
}
.inlineBlock {
  display: inline-block;
  font-size: 18px;
}

.box {
  .top {
    text-align: center;
  }

  .left {
    float: left;
    width: 60px;
  }

  .right {
    float: right;
    width: 40px;
  }

  .bottom {
    clear: both;
    text-align: center;
  }
  .left .el-tooltip__popper,
  .right .el-tooltip__popper {
    padding: 8px 10px;
  }
  .ghost {
    opacity: 0.5;
    background: #c8ebfb !important;
  }
}
.fnIcon {
  min-width: 20px;
  font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/aside/aside.vue